import { ref } from "vue";

/** Bumped when public comments change so Messages sidebar re-sorts / refreshes previews. */
export const ticketSidebarListRevision = ref(0);

export function bumpTicketSidebarListRevision(): void {
  ticketSidebarListRevision.value += 1;
}
